import axios from "axios";

// chrome新版下载文件(流文件)
export function exportFileBlobNew(res, name) {
  const binaryData: Array<any> = [];
  binaryData.push(res);
  const href = window.URL.createObjectURL(new Blob(binaryData));
  const a = document.createElement("a");
  a.href = href;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  //
  document.body.removeChild(a);
}
// 下载文件(流文件)
export function exportFileBlob(res, type) {
  const href = window.URL.createObjectURL(res);
  const a = document.createElement("a");
  a.href = href;
  a.download = type;
  document.body.appendChild(a);
  a.click();
  //
  document.body.removeChild(a);
}

// 下载文件(url地址)
export function exportFileUrl(res, filename) {
  const href = res;
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  // a.target = "_blank"; // 新窗口打开链接
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
function getBlob(url) {
  return new Promise(resolve => {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.setRequestHeader('Accept', 'application/pdf')
    xhr.responseType = 'blob'
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(xhr.response)
      }
    }
    xhr.send()
  })
}
// 下载文件(url地址)新窗口
export function exportFileUrlNew(res, filename) {
  // console.log('filenamessssasad',filename)
  // getBlob("https://ict-static.obs.cn-east-2.myhuaweicloud.com/zjhuawei/2021%E5%8D%8E%E4%B8%BA%E6%95%B0%E5%AD%97%E5%8C%96%E8%BD%AC%E5%9E%8B%E6%B4%9E%E5%AF%9F%E6%8A%A5%E5%91%8A.pdf").then((blob)=>{
  //   const href = res;
  //   const a = document.createElement("a");
  //   a.href = window.URL.createObjectURL(blob);
  //   a.download = filename;
  //   a.target = "_blank"; // 新窗口打开链接
  //   document.body.appendChild(a);
  //   a.click();
  //   document.body.removeChild(a);
  // })
  const href = res;
  const a = document.createElement("a");
  a.href = href
  a.download = filename;
  a.target = "_blank"; // 新窗口打开链接
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
// 下载文件(url地址) 多文件
export function downloadFileUrlAsync(arr) {
  arr.forEach((item, index) => {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.style.height = "0";
    iframe.src = item;
    document.body.appendChild(iframe);
    // 不能马上将 iframe 删除，否则也会出现取消的情况
    setTimeout(() => {
      iframe.remove();
    }, 3000);
  });
}
// 单文件文件流下载 解决txt
export function downloadFile(url, fileName) {
  const x = new XMLHttpRequest();
  x.open("GET", url, true);
  x.responseType = "blob";
  x.onload = function(e) {
    const url = window.URL.createObjectURL(x.response);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  x.send();
}
// 多txt,pdf文件下载
export function downloadFileUrlMuti(arr) {
  //

  arr.forEach((item, index) => {
    const x = new window.XMLHttpRequest();
    x.open("GET", item, true);
    x.responseType = "blob";
    x.onload = () => {
      const url = window.URL.createObjectURL(x.response);
      const a = document.createElement("a");
      a.href = url;
      a.target = "_blank";
      a.click();
    };
    x.send();
  });
}
//多文件下载
export function downloadFileUrlMutiple(arr, fileName) {
  // const self  = this;
  arr.forEach((item, index) => {
    // const self = this;
    const a = document.createElement("a");
    a.href = item;
    a.download = fileName[index];
    a.target = "_blank";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  });
}
//txt多文件文件流下载
export function downloadFileUrl(arr) {
  Promise.all(
    arr.map((item, index) => {
      //- thiszhi指向绑定
      return axios
        .get(item, {
          responseType: "blob"
        })
        .then(res => {
          //
          const url = window.URL.createObjectURL((res as any).request.response);
          const a = document.createElement("a");
          a.href = url;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        });
    })
  )
    .then(data => {
      // //
      // callback();
    })
    .catch(error => {
      // //
      // callback();
    });
}

/**
 * @method 下载单个文件（文件类型可任意：.png、txt、office文档、.psd等）
 * @param { String } url - 文件的http完整路径, 如：http: //xxx.png
 * @param { String } fileName - 文件名，注意是要带文件后缀名，如：xxx.png
 * @doc https://blog.csdn.net/weixin_39547158/article/details/110851570
 */
export function downloadFilea(url: string, fileName: string) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.upload.onprogress = e => {
      if (e.lengthComputable) {
        const progress = e.loaded / e.total;
      }
    };
    xhr.onload = function() {
      const url = window.URL.createObjectURL(xhr.response);
      const eleLink = document.createElement("a");
      eleLink.href = url;
      eleLink.download = `${fileName}`;
      eleLink.style.display = "none";
      document.body.appendChild(eleLink);
      eleLink.click();
      document.body.removeChild(eleLink);
      resolve("success");
    };
    xhr.onerror = e => {
      reject(e);
    };
    xhr.send();
  });
}

// 下载文件名在请求头的流文件
/**
 *  res: {
 *    headers: {},
 *    data: 流文件
 *  }
 */
export function downLoadByName(res) {
  const fileNames = res.headers["Content-Disposition"]
  if (fileNames) {
    //解码
    const fileName = decodeURIComponent(fileNames.match(/=(.*)$/)[1]);
    // 处理返回的文件流
    const content = res.data;
    const blob = new Blob([content], {
      type: "application/octet-stream; charset=utf-8"
    });
    const a = document.createElement("a"); //创建一个a标签
    a.download = fileName; //指定文件名称
    a.style.display = "none"; //页面隐藏
    a.href = URL.createObjectURL(blob); // href用于下载地址
    document.body.appendChild(a); //插到页面上
    a.click(); //通过点击触发
    URL.revokeObjectURL(a.href); //释放URL 对象
    document.body.removeChild(a); //删掉a标签
  } else {
    // console.log("未拿到文件名");
  }
}
